import React from 'react';
import { Link } from '@one-thd/sui-atomic-components';
import { APPLIANCE_FITS } from '../../constants';

const BG_BY_STATUS = {
  [APPLIANCE_FITS.FITS]: 'sui-bg-success-subtle',
  [APPLIANCE_FITS.FITS_WITH_OVERFLOW]: 'sui-bg-success-subtle',
  [APPLIANCE_FITS.MOSTLY_FITS]: 'sui-bg-warning-subtle',
  [APPLIANCE_FITS.DOES_NOT_FIT]: 'sui-bg-danger-subtle'
};


const Card = ({ label, value, icon }) => {

  return (
    <div className="sui-p-1 sui-rounded">
      <div className="sui-flex sui-items-start sm:sui-items-center md:sui-items-center lg:sui-items-start xl:sui-items-center sui-gap-1" style={{ fontSize: 14 }}>
        <span className="sui-inline-flex sui-my-1 sui-shrink-0">{icon}</span>
        <div className="sui-flex sui-pl-1 sui-flex-col
                        sm:sui-flex-row
                        md:sui-flex-row
                        lg:sui-flex-col
                        xl:sui-flex-row
                        sui-items-start
                        xl:sui-items-center sui-text-sm sui-font-normal sui-leading-tight">
          <span className="sui-text-sm">{label}&nbsp;</span>
          <span className="sui-text-sm sui-whitespace-nowrap">{value} in.</span>
        </div>
      </div>
    </div>
  );
};

export default function FitResultsCards({ fitResult, dimensions, onEdit }) {
  if (!fitResult) {
    return null;
  }

  const { fits, widthFits, heightFits, depthFits, widthIcon, heightIcon, depthIcon } = fitResult;
  const bgClass = BG_BY_STATUS[fits] || 'sui-bg-primary';

  return (
    <>
      <div className={`sui-rounded sui-p-1 sui-mt-1 ${bgClass}`}>
        <div className="sui-grid sui-grid-cols-3 sm:sui-grid-cols-4 lg:sui-grid-cols-3 2xl:sui-grid-cols-3 sui-w-full">
          <div className="sui-flex sui-justify-start">
            <Card label="Width:" value={dimensions.width || '0'} globalStatus={fits} isDimOk={!!widthFits} icon={widthIcon} />
          </div>
          <div className="sui-flex sui-justify-center">
            <Card label="Height:" value={dimensions.height || '0'} globalStatus={fits} isDimOk={!!heightFits} icon={heightIcon} />
          </div>
          <div className="sui-flex sui-justify-end">
          <Card label="Depth:" value={dimensions.depth || '0'} globalStatus={fits} isDimOk={!!depthFits} icon={depthIcon} />
          </div>
          <div
            className="sui-hidden
                        sm:sui-inline-flex
                        lg:sui-hidden
                        2xl:sui-inline-flex
                        sui-items-center
                        sm:sui-col-start-4
                        sui-justify-end
                        sui-pl-6
                      "
          >
            <Link component="button" onClick={onEdit} data-testid="fit-compatibility-edit-dimensions-inline" variant="body-xs" >
              Edit Dimensions
            </Link>
          </div>
        </div>
      </div>
      <div className="sui-flex
                      sm:sui-hidden
                      lg:sui-flex
                      2xl:sui-hidden
                      sui-justify-end sui-mt-2
                      "
      >
        <Link component="button" onClick={onEdit} data-testid="fit-compatibility-edit-dimensions-breakpoint" variant="body-xs">
          Edit Dimensions
        </Link>
      </div>
    </>
  );
}

